import { render } from "./BottomNavBar.vue?vue&type=template&id=f1db970e"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"

import "./BottomNavBar.vue?vue&type=style&index=0&id=f1db970e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__